"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports["default"] = void 0;
var stickyDrawerConfig = {
  style: {
    background: "var(--color-functional-panelLight)",
    boxShadow: "var(--elevation-shadow-xl)",
    padding: {
      small: "var(--spacing-global-space6) var(--spacing-global-space5)",
      medium: "var(--spacing-global-space7) var(--spacing-global-space6)"
    }
  }
};
var style = exports.style = stickyDrawerConfig.style;
var _default = exports["default"] = stickyDrawerConfig;